import { toast } from "sonner";

import { useNavigate } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useCreatePromotionMutation } from "../api/queries";
import { PromotionForm } from "../ui/PromotionForm";

export function PromotionCreatePage() {
  const nav = useNavigate({ from: "/app/loyalty/promotions/create" });
  const createPromotion = useCreatePromotionMutation();

  const defaultStart = new Date();
  defaultStart.setHours(0, 0, 0, 0);
  const defaultEnd = new Date();
  defaultEnd.setDate(defaultEnd.getDate() + 7);
  defaultEnd.setHours(23, 59, 0, 0);

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            {
              label: "ໂປຣໂມຊັນ",
              to: "/app/loyalty/promotions",
            },
            {
              label: "ສ້າງໂປຣໂມຊັນ",
            },
          ]}
        />
      </Header>
      <Main>
        <div className="mb-6 flex flex-wrap items-center justify-between gap-2">
          <div>
            <h2 className="font-bold text-2xl tracking-tight">ສ້າງໂປຣໂມຊັນ</h2>
            <p className="text-muted-foreground">
              ຕັ້ງຄ່າກົດໂປຣໂມຊັນ ເວລາ ແລະ ຂອບເຂດການສົມຄວນ
            </p>
          </div>
        </div>

        <PromotionForm
          defaultValues={{
            name: "",
            type: "PERCENT",
            startAt: defaultStart.toISOString(),
            endAt: defaultEnd.toISOString(),
            minOrderTotal: null,
            percentValue: null,
            fixedAmount: null,
            globalLimit: null,
            perCustomerLimit: 1,
            priority: 10,
            isActive: true,
            scopes: [],
          }}
          onSubmit={async (payload) => {
            try {
              const created = await createPromotion.mutateAsync(payload);
              toast.success("ສ້າງໂປຣໂມຊັນສຳເລັດ");
              nav({
                to: "/app/loyalty/promotions/$promotionId/edit",
                params: { promotionId: created.id },
              });
            } catch {
              //
            }
          }}
          submitting={createPromotion.isPending}
          onCancel={() => nav({ to: "/app/loyalty/promotions" })}
          submitLabel="ບັນທຶກໂປຣໂມຊັນ"
        />
      </Main>
    </>
  );
}
